import React, { useEffect, useState } from 'react';
import './CooldownSpinner.css';
import { subscribe, unsubscribe } from '../../utils/events';

export const spinnerStrokeDasharray = 283;

const CooldownSpinner = ({ style, ref, id, cooldownTime }) => {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		function onProgress(progress) {
			setProgress(progress);
		}
		if (id) {
			subscribe(id, onProgress);
			return () => unsubscribe(id, onProgress);
		}
	}, [id]);

	const remainingTime = (cooldownTime - cooldownTime * progress) / 1000;
	let textTime = "";

	if (remainingTime > 60) {
		textTime = `${Math.floor(remainingTime / 60)}m ${Math.floor(remainingTime % 60).toString().padStart(2, '0')}s`;
	} else {
		textTime = `${remainingTime.toFixed(1)}s`;
	}

	return (
		<div ref={ref} className="progress-spinner-container" style={{ ...style, '--progress': spinnerStrokeDasharray * progress * -1 }}>
			<svg className="progress-spinner" viewBox="0 0 100 100">
				<circle
					className="track"
					cx="50"
					cy="50"
					r="45"
					strokeWidth="6px"
					fill="none"
				/>
				<circle
					className="progress"
					cx="50"
					cy="50"
					r="45"
					strokeWidth="9px"
					fill="none"
					strokeDasharray={spinnerStrokeDasharray}
					strokeLinecap='round'
				/>
			</svg>
			<span className='progress-text'>
				{textTime}
			</span>
		</div>
	);
};

export default CooldownSpinner;
